import { BookWidgetFields } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { SavedTripList } from '../../models/core-apis/saved-search.interfaces';

export const updatePassengerFieldFromSavedSearch = (
  savedSearchData: SavedTripList,
  bookWidgetFields: BookWidgetFields,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig
) => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  if (!bookWidgetFieldsMasterConfig.passengerField?.disable) {
    let selectedPaxValue = savedSearchData.passengerCount.toString();

    const dropdownOptions = [
      ...updatedBookWidgetFields.passengerField.dropdownOptions.map((data) => ({
        ...data,
        selected: false
      }))
    ];

    const indexOfSelectedPaxValue = dropdownOptions.findIndex(
      ({ value }) => value === selectedPaxValue
    );

    if (indexOfSelectedPaxValue === -1) {
      selectedPaxValue = dropdownOptions[0].value;
      dropdownOptions[0].selected = true;
    } else {
      dropdownOptions[indexOfSelectedPaxValue].selected = true;
    }

    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      passengerField: {
        ...updatedBookWidgetFields.passengerField,
        selectedPaxValue,
        dropdownOptions,
        disable: false
      }
    };
  }

  return updatedBookWidgetFields;
};
